import React from "react";
import MenuGrid from "../MenuGrid";

const SECTIONS = [
  {
    title: "Artículos",
    items: [
      // { label: "Marcas",            icon: "far fa-copyright",        href: "/Marcas",                  perm: "menu_articulos" },
      { label: "Colecciones",       icon: "fas fa-calendar-alt",     href: "/Colecciones",             perm: "menu_articulos" },
      { label: "Departamentos",     icon: "fas fa-list-ul",          href: "/ListadoDepartamentos",    perm: "menu_articulos" },
      // { label: "Sub Departamentos", icon: "fas fa-list-ul",          href: "/ListadoSubDepartamentos", perm: "menu_articulos" },
      // { label: "Clases",            icon: "fas fa-bars",             href: "/ListadoClases",           perm: "menu_articulos" },
      // { label: "Etiquetas",         icon: "fas fa-bars",             href: "/ListadoSubClases",        perm: "menu_articulos" },
      { label: "Tallas",            icon: "fas fa-ruler-horizontal", href: "/ListadoTallas",           perm: "menu_articulos" },
      { label: "Artículos",         icon: "fas fa-tshirt",           href: "/ListadoArticulos",        perm: "menu_articulos" },
    ],
  },
];

function BotonesArticulos() {
  return (
    <MenuGrid
      title="Artículos"
      subtitle="Catálogo de artículos y sus clasificaciones"
      icon="fas fa-tshirt"
      accent={{ color: "#8b5cf6", bg: "#f5f3ff" }}
      gate="menu_articulos"
      sections={SECTIONS}
    />
  );
}

export default BotonesArticulos;
